export const PACHI_ONLY_COLUMN = [
  'start',
  'S1',
  'base',
  'BY',
  'BYmin',
  'T1Y',
  '250tama_start',
  'TS',
  'SA',
  'BA',
  'TO',
  'T1O'
];
export default PACHI_ONLY_COLUMN;
